<template>
	<div class="agent-page">
		<div class="ui top attached segment agent-header">
			<div>
				<h2 class="ui header">
					<i class="robot icon"></i>
					<div class="content">
						AI Agent
						<div class="sub header">和我的智能分身聊聊</div>
					</div>
				</h2>
			</div>
			<button class="ui basic button" @click="resetSession">
				<i class="redo icon"></i>新会话
			</button>
		</div>

		<div ref="messages" class="ui attached segment agent-messages">
			<div class="agent-empty" v-if="messages.length === 0">
				<i class="comments outline icon"></i>
				<p>可以问我关于博客、项目、最近信息，或者让它结合知识库回答。</p>
			</div>
			<div class="agent-message" :class="message.role" v-for="message in messages" :key="message.id">
				<div class="agent-bubble">
					<div class="agent-role">{{ message.role === 'user' ? '你' : 'Agent' }}</div>
					<div class="agent-content">{{ message.content }}</div>
				</div>
			</div>
			<div class="agent-message assistant" v-if="loading">
				<div class="agent-bubble">
					<div class="agent-role">Agent</div>
					<div class="agent-content">正在思考...</div>
				</div>
			</div>
		</div>

		<div class="ui bottom attached segment agent-input">
			<textarea
					v-model="input"
					placeholder="输入你想问的问题..."
					:disabled="loading"
					@keydown.enter.exact.prevent="sendMessage"
			></textarea>
			<button class="ui primary icon button" :class="{loading}" :disabled="!canSend" @click="sendMessage">
				<i class="paper plane icon"></i>
			</button>
		</div>
	</div>
</template>

<script>
	import {chatWithAgent} from '@/api/agent'

	export default {
		name: 'Agent',
		data() {
			return {
				input: '',
				loading: false,
				threadId: window.localStorage.getItem('agent_thread_id') || '',
				messages: []
			}
		},
		computed: {
			canSend() {
				return this.input.trim().length > 0 && !this.loading
			}
		},
		methods: {
			async sendMessage() {
				const content = this.input.trim()
				if (!content || this.loading) {
					return
				}

				this.messages.push({id: Date.now(), role: 'user', content})
				this.input = ''
				this.loading = true
				this.scrollToBottom()

				try {
					const res = await chatWithAgent({
						message: content,
						thread_id: this.threadId || undefined
					})
					this.threadId = res.data.thread_id
					window.localStorage.setItem('agent_thread_id', this.threadId)
					this.messages.push({id: Date.now() + 1, role: 'assistant', content: res.data.answer})
				} catch (e) {
					this.messages.push({
						id: Date.now() + 1,
						role: 'assistant',
						content: 'Agent 暂时没有响应，请稍后再试。'
					})
				} finally {
					this.loading = false
					this.scrollToBottom()
				}
			},
			resetSession() {
				this.threadId = ''
				this.messages = []
				window.localStorage.removeItem('agent_thread_id')
			},
			scrollToBottom() {
				this.$nextTick(() => {
					const el = this.$refs.messages
					if (el) {
						el.scrollTop = el.scrollHeight
					}
				})
			}
		}
	}
</script>

<style scoped>
	.agent-page {
		min-height: 640px;
	}

	.agent-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.agent-header .ui.header {
		margin: 0;
	}

	.agent-messages {
		height: 520px;
		overflow-y: auto;
		background: #f7f8fa;
	}

	.agent-empty {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #777;
		text-align: center;
	}

	.agent-empty i {
		font-size: 3em;
		margin-bottom: .5em;
		color: #48dbfb;
	}

	.agent-message {
		display: flex;
		margin: 12px 0;
	}

	.agent-message.user {
		justify-content: flex-end;
	}

	.agent-message.assistant {
		justify-content: flex-start;
	}

	.agent-bubble {
		max-width: 82%;
		padding: 12px 14px;
		border-radius: 8px;
		background: #ffffff;
		box-shadow: 0 1px 4px rgba(0, 0, 0, .08);
		white-space: pre-wrap;
		word-break: break-word;
	}

	.agent-message.user .agent-bubble {
		background: #e8f8fd;
	}

	.agent-role {
		margin-bottom: 6px;
		font-size: 12px;
		color: #777;
	}

	.agent-content {
		line-height: 1.7;
		color: #333;
	}

	.agent-input {
		display: flex;
		gap: 10px;
		align-items: flex-end;
	}

	.agent-input textarea {
		flex: 1;
		min-height: 64px;
		max-height: 160px;
		padding: 10px 12px;
		border: 1px solid #ddd;
		border-radius: 6px;
		resize: vertical;
		outline: none;
		line-height: 1.6;
	}

	.agent-input textarea:focus {
		border-color: #48dbfb;
	}

	.agent-input .button {
		width: 48px;
		height: 42px;
	}

	@media screen and (max-width: 767px) {
		.agent-page {
			min-height: 560px;
		}

		.agent-messages {
			height: 440px;
		}

		.agent-bubble {
			max-width: 92%;
		}
	}
</style>
